import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { Component, Inject, OnInit } from '@angular/core'
// TODO:Spartacus - // TODO:Spartacus - Class ModalService has been removed and is no longer part of the public API. Use 'LaunchDialogService' instead. For more information, see the 5.0 migration guide.

@Component({
    selector: 'app-short-oversupplied-modal-collected',
    templateUrl: './short-oversupplied-modal-collected.component.html',
    styleUrls: ['./short-oversupplied-modal-collected.component.scss'],
    standalone: false
})
export class ShortOversuppliedModalCollectedComponent implements OnInit {
  public stockCollected = true
  changeclaims: any
  changeclaims2: any

  constructor(
    @Inject(DIALOG_DATA) public data: any,
    private dialogRef: DialogRef<ShortOversuppliedModalCollectedComponent>
  ) {}

  ngOnInit(): void {}
  changeclaim2(e) {
    this.changeclaims2 = e.target.checked
    this.dialogRef.close({ data: this.changeclaims2 } as any)
  }
  closeModal() {
    this.dialogRef.close({ data: this.changeclaims2 } as any)
  }
}
